import { render } from "./PruebaCortaView.vue?vue&type=template&id=02846c88"
import script from "./PruebaCortaView.vue?vue&type=script&lang=js"
export * from "./PruebaCortaView.vue?vue&type=script&lang=js"

import "./PruebaCortaView.vue?vue&type=style&index=0&id=02846c88&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__